export default __webpack_public_path__ + "images/d57d346e49c2dceb7e097981252f2b29-EE_SlideDeckBOOK1024_9.png";